class Actions {
  constructor(document) {
    document = document || {}
    this.name = document.name || ''
    this.title = document.title || ''
    this.value = document.value || false
  }
}

module.exports = Actions
